<template>
	<page>
		<module>
			<view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="订单号">
							<c-input name="order_no" placeholder="销售单号"></c-input>
						</m-search-item>
						<m-search-item label="客户名称">
							<c-input name="customer_name" placeholder="客户名称"></c-input>
						</m-search-item>
						<m-search-item label="售卖类型">
							<c-select name="sell_type" :options="sellTypeOptions"></c-select>
						</m-search-item>
						<m-search-item label="创建人">
							<c-input name="create_user_realname" placeholder="创建人"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_offline_pay_check_batch')" color="main" prepend-icon="tf-batch" @click="batchCheck()">批量核销</c-button>
					<c-button v-if="auth('b_offline_pay_check_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<template #product_name="{data}">
					<m-product-info :name="data.product_name" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>

				<template #produce_code="{data}">
					{{data.produce_code}} <c-link color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #imei="{data}">
					{{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #level_type="{data}">
					<c-state v-if="data.level_type" tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
					<span v-else>-</span>
				</template>

				<template #sell_type="{data}">
					<!--拆机行悬停动态查询拆机项详情（与授信账单/线下订单列表同口径）-->
					<c-tooltip v-if="data.sell_type == 2" position="bottom" color="white" @mouseenter.native="loadDismantleItems(data)">
						<span class="sell-type-dismantle">
							<c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
							<i class="tf tf-detail"></i>
						</span>
						<template #tip>
							<p v-if="getDismantleState(data).loading" class="m-dismantle-item">正在查询拆机项...</p>
							<p v-else-if="getDismantleState(data).error" class="m-dismantle-item">{{getDismantleState(data).error}}</p>
							<template v-else>
								<p v-for="(item, index) in getDismantleState(data).items" :key="index" class="m-dismantle-item">{{item}}</p>
								<p v-if="!getDismantleState(data).items.length" class="m-dismantle-item">暂无拆机项</p>
							</template>
						</template>
					</c-tooltip>
					<c-state v-else async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
				</template>

				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<template #sale_price="{data}">
					<span style="color: green;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #pay_channel="{data}">
					<c-state v-if="data.pay_channel" dict="OFFLINE_PAY_CHANNEL" tag :value="data.pay_channel"></c-state>
					<span v-else>-</span>
				</template>

				<template #pay_voucher_url="{data}">
					<c-file v-if="data.pay_voucher_url" :src="data.pay_voucher_url" media></c-file>
					<span v-else>-</span>
				</template>

				<template #check_status="{data}">
					<c-state dict="OFFLINE_PAY_CHECK_STATUS" tag :value="data.check_status"></c-state>
				</template>

				<c-table-column
						type="button"
						label="操作"
						width="150"
						button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_offline_pay_check_detail')" icon="tf-detail" @click="orderDetail(data)">详情</c-table-button>
						<c-table-button v-if="auth('b_offline_pay_check') && data.check_status == 0" icon="tf-accept" @click="openCheckDialog(data)">核销</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!--核销弹窗-->
			<offline-pay-check-dialog ref="checkDialog" @resolve="$refs.view.update()"></offline-pay-check-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	import {asyncMapState} from '@/store';
	import offlinePayCheckDialog from './offline_pay_check_dialog.vue';

	export default {
		name: 'm_offline_pay_check',

		components: {
			offlinePayCheckDialog
		},

		data() {
			return {
				workType: 124,
				sellTypeOptions: [{
					name: '整机',
					value: 1
				}, {
					name: '拆机',
					value: 2
				}],
				/**售卖类型列悬停拆机项查询状态：key=order_id，每次悬停实时查询不跨次复用 */
				dismantleMap: {}
			}
		},

		computed: {
			...mapState(['saasInfo']),
			...asyncMapState(['DISMANTLE_ITEM'])
		},

		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},
			
			/*********悬停售卖类型列：实时查询该订单商品的拆机项**********/
			loadDismantleItems(data) {
				if (data.sell_type != 2) return;
				var key = data.order_id;
				var state = this.dismantleMap[key];
				// 在途请求未返回前不重复发起，避免鼠标移动抖动产生并发查询
				if (state && state.loading) return;
				this.$set(this.dismantleMap, key, {
					loading: true,
					error: '',
					products: []
				});
				this.request({
					url: '/offline/sale/order/dismantleItems',
					data: {
						order_no: data.order_no
					},
					fail: (code, obj, msg) => {
						// 悬停查询失败不弹全局提示，错误信息在浮层内展示
						this.$set(this.dismantleMap, key, {
							loading: false,
							error: msg || '拆机项查询失败',
							products: []
						});
						return false;
					},
					success: result => {
						this.$set(this.dismantleMap, key, {
							loading: false,
							error: '',
							products: (result && result.products) || []
						});
					}
				});
			},
			
			/*********获取当前行拆机项浮层状态（查询中/失败/拆机项名称列表）**********/
			getDismantleState(data) {
				var state = this.dismantleMap[data.order_id] || {};
				var items = [];
				if (!state.loading && !state.error) {
					// 接口按订单号返回全部商品，取当前行商品（列表行 id 即订单商品ID）的拆机项
					var product = (state.products || []).find(item => item.id == data.id);
					items = this.formatDismantleItems(product ? product.dismantle_items : '');
				}
				return {
					loading: !!state.loading,
					error: state.error || '',
					items: items
				};
			},
			
			/*********解析拆机项并按字典翻译显示名称（存储为字典value数组，与开单页口径一致）**********/
			formatDismantleItems(value) {
				if (!value) return [];
				var list = value;
				if (typeof list == 'string') {
					try {
						list = JSON.parse(list);
					} catch (e) {
						return [value];
					}
				}
				if (!Array.isArray(list)) return [];
				var dict = this.DISMANTLE_ITEM || [];
				return list.map(item => {
					// 数组项为字典value或{value,name}对象，统一取value后翻译为字典名称展示
					var val = String(item && item.value ? item.value : item);
					var option = dict.find(dic => String(dic.value) == val);
					return option ? option.name : val;
				}).filter(item => item);
			},

			/*********查看订单详情**********/
			orderDetail(data) {
				this.globalDialog('saleOrderDetail', {
					props: {
						orderType: 1
					},
					data: {
						orderId: data.order_id
					}
				});
			},

			/*********打开核销弹窗**********/
			openCheckDialog(data) {
				this.$refs.checkDialog.open(data);
			},

			/*********批量核销**********/
			batchCheck() {
				var listRef = this.$refs.view && this.$refs.view.$refs.list;
				var rows = ((listRef && listRef.getRow('selected')) || []).map(item => item.data || item);
				if (!rows.length) {
					this.$message({message: '请先选择记录', type: 'warn'});
					return;
				}
				// 按支付单去重，同一支付单多商品行只核销一次
				var payMap = {};
				rows.forEach(item => {
					payMap[item.union_pay_id] = item;
				});
				var pays = Object.keys(payMap).map(key => payMap[key]);
				var unchecked = pays.filter(item => item.check_status == 0);
				if (!unchecked.length) {
					this.$message({message: '请选择“待核销”状态的记录进行操作', type: 'warn'});
					return;
				}
				if (unchecked.length < pays.length) {
					this.$message({message: '所选记录中包含已核销的支付单，已自动过滤', type: 'warn'});
				}
				var ids = unchecked.map(item => item.union_pay_id);
				this.$confirm({
					title: '批量核销',
					message: '是否将选择的【' + ids.length + '】笔线下支付进行核销操作？',
					resolve: () => {
						this.request({
							url: '/offline/pay/check/check',
							data: {
								ids: ids
							},
							loading: true,
							success: () => {
								this.$message({
									message: '核销成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	/* 拆机售卖类型：标签+详情图标 */
	.sell-type-dismantle {
		display: inline-flex;
		align-items: center;
		gap: 2px;

		.tf-detail {
			font-size: 12px;
			color: #ff6900;
			cursor: help;
		}
	}

	.m-dismantle-item {
		margin: 0;
		line-height: 20px;
	}
</style>
